import { serializeContact } from "@/components/autocomplete/usePresenterContacts";
import type { DustMonitorClass, DustMonitorClassNew } from "@/views/dustMonitorClass/dustMonitorClass";
import { toTimeOnlyString } from "@modernary/mui/utils/fk";

export default {
  addAuthRequestFields,
  getInitialData,
  skinnyResponseAdapter,
  responseAdapter,
  requestAdapter,
  toFormkit,
  fromFormkit,
};

function addAuthRequestFields(entity: DustMonitorClass) {
  entity._authRequestFields = ["id", "canInvite"];
  return entity;
}
function getInitialData() {
  const result = {} as DustMonitorClass; //TODO: ts
  return addAuthRequestFields(result);
}

/** Be sure to await this when using it. Commonly used for lists and child lists */
async function skinnyResponseAdapter(response: { data: DustMonitorClass }) {
  addAuthRequestFields(response.data);

  if (!response.data.presentedByObj) response.data.presentedByObj = {};
  if (response.data.presentedBy) {
    response.data.presentedByObj = JSON.parse(response.data.presentedBy);
  }

  if (!response.data.coHostedByObj) response.data.coHostedByObj = {};
  if (response.data.coHostedBy) {
    response.data.coHostedByObj = JSON.parse(response.data.coHostedBy);
  }

  return response.data;
}

/** Be sure to await this when using it. */
async function responseAdapter(response: { data: DustMonitorClass }) {
  await skinnyResponseAdapter(response);
  return response.data;
}

function requestAdapter(data: DustMonitorClass) {
  if (!data.id) {
    delete data.attendees;
  } else if (data.attendees) {
    data.attendees = data.attendees.map((attendee) => ({
      id: attendee.id,
      hasAttended: attendee.hasAttended ?? null,
      testScore: attendee.testScore ?? null,
      dustMonitorCardNumber: attendee.dustMonitorCardNumber ?? null,
      ...(data.hasIssuedCards
        ? {}
        : {
            hasAttendedVee: attendee.hasAttendedVee ?? null,
            hasPassedVee: attendee.hasPassedVee ?? null,
          }),
    })) as DustMonitorClass["attendees"];
  }

  return data;
}

// Convert server data for use in the page's form
function toFormkit<T extends DustMonitorClass | DustMonitorClassNew>(data: T) {
  if (!data.presentedByObj) data.presentedByObj = {};
  if (!data.coHostedByObj) data.coHostedByObj = {};
}

// Convert formkit data to prep it for sending to the server
function fromFormkit(data: DustMonitorClass) {
  if (data.classLocalTime) data.classLocalTime = toTimeOnlyString(data.classLocalTime);

  data.presentedByEmail = data.presentedByObj?.email || null;
  data.presentedBy = serializeContact(data.presentedByObj);
  data.coHostedByEmail = data.coHostedByObj?.email || null;
  data.coHostedBy = serializeContact(data.coHostedByObj);
}
